import { render, staticRenderFns } from "./CbcxTickets.vue?vue&type=template&id=4f77bc8c&scoped=true&"
import script from "./CbcxTickets.vue?vue&type=script&lang=js&"
export * from "./CbcxTickets.vue?vue&type=script&lang=js&"
import style0 from "./CbcxTickets.vue?vue&type=style&index=0&id=4f77bc8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77bc8c",
  null
  
)

export default component.exports